export const scene = {
  enableGlobal: [{
    value: 1, label: '全局'}, {
    value: 2, label: '非全局'
  }],
  sceneType: [{
    value: 1, label: '系统'
  }, {
    value: 2, label: '个人'
  }],
  sceneStatus: [{
    value: 1, label: '正常'
  }, {
    value: 2, label: '禁用'
  }]
}

export default {
  scene
}



// WEBPACK FOOTER //
// ./src/data/scene.js